<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="consultation"></progress-components>
      <v-form ref="form" class="mt-12">
        <interview-link></interview-link>
        <v-card
          class="mx-auto mt-1"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診察_咳</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="cough"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診察_呼吸苦</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="shortnessOfBreath"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診察_咽頭痛</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="pharyngitis"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診察_倦怠感</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="senseOfFatigue"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診察_胃腸症状</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="gastrointestinal"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診察_脱水症状</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="dehydration"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
      </v-form>
    </v-container>
    <v-container>
      <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNextPage"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNextPage"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, computed, ref } from 'vue'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useFormValidator } from '@/func/useFormValidator'
import { useCrossSectional } from '@/const/form/useCrossSectional'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/MedicalRecordTitle.vue'
import ProgressComponents from '@/components/MedicalRecordProgress.vue'
import InterviewLink from '@/components/InterviewLink.vue'
import { useScreenOperation } from '@/func/useScreenOperation'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents,
    'interview-link': InterviewLink
  },
  setup() {
    const { scrollToTop, fromConfirmScreen, scrollToErrorPosition } = useScreenOperation()
    const fromConfirm = computed(() => fromConfirmScreen())
    const { selectFlagIndicators } = useCrossSectional()
    const { required } = useFormValidator()
    const form = ref(null)

    logger.info('MedicalRecord Consultation')
    scrollToTop()

    const store = useStore()
    const cough = computed({
      get: () => store.state.medicalRecord.cough,
      set: (value) => store.dispatch('medicalRecord/setCough', value)
    })
    const shortnessOfBreath = computed({
      get: () => store.state.medicalRecord.shortnessOfBreath,
      set: (value) => store.dispatch('medicalRecord/setShortnessOfBreath', value)
    })
    const pharyngitis = computed({
      get: () => store.state.medicalRecord.pharyngitis,
      set: (value) => store.dispatch('medicalRecord/setPharyngitis', value)
    })
    const senseOfFatigue = computed({
      get: () => store.state.medicalRecord.senseOfFatigue,
      set: (value) => store.dispatch('medicalRecord/setSenseOfFatigue', value)
    })
    const gastrointestinal = computed({
      get: () => store.state.medicalRecord.gastrointestinal,
      set: (value) => store.dispatch('medicalRecord/setGastrointestinal', value)
    })
    const dehydration = computed({
      get: () => store.state.medicalRecord.dehydration,
      set: (value) => store.dispatch('medicalRecord/setDehydration', value)
    })

    const router = useRouter()
    const toBack = () => router.go(-1)

    const clickedNextPage = async () => {
      const result = await form.value.validate()
      if (!result.valid) {
        scrollToErrorPosition()
        return
      }
      if (fromConfirm.value) {
        router.push('/record/confirm')
      } else {
        router.push('/record/assessment')
      }
    }
    return {
      fromConfirm,
      clickedNextPage,
      toBack,
      required,
      selectFlagIndicators,
      form,
      cough,
      shortnessOfBreath,
      pharyngitis,
      senseOfFatigue,
      gastrointestinal,
      dehydration
    }
  }
})
</script>
